module.exports = __webpack_public_path__ + "static/media/backward.faf1a810.svg";